/*
 * @Author: 曹捷
 * @Date: 2020-02-26 14:54:27
 * @LastEditors: 曹捷
 * @LastEditTime: 2020-04-16 16:17:15
 * @Description: file content
 */

import svgIcon from './SvgIcon/svg-icon.vue'
import ajax from './ajax'
import nodata from './nodata/nodata.vue'
import obitCity from './obit-city/index.vue'
import obitDict from './obit-dict/obit-dict.vue'
import contentForm from './content-form/index.vue'
import obitProgress from './obit-progress/obit-progress.vue'
import obitUpload from './obit-upload/obit-upload.vue'
import titleWrap from './title-wrap/title-wrap.vue'
import obitTableTree from './obit-table-tree/table-tree'
import obitOrg from  './obit-org/obit-org'
import obitCascader from  './obit-cascader/obit-cascader'
export {
    svgIcon,
    ajax,
    nodata,
    obitCity,
    obitDict,
    contentForm,
    obitProgress,
    obitUpload,
    titleWrap,
    obitTableTree,
    obitOrg,
    obitCascader
}